import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService, SessionUserService } from 'core-client/api';
import { rememberPostLoginUrl } from './post-login-url';

export const authGuard = async (
  _route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): Promise<boolean | UrlTree> => {
  const authService = inject(AuthService);
  const sessionUser = inject(SessionUserService);
  const router = inject(Router);

  await authService.whenReady();

  if (!authService.isAuthenticated()) {
    return router.parseUrl('/login');
  }
  if (!sessionUser.getUser()) {
    // Authenticated but BFF session not hydrated (reload/deep link) —
    // the callback route is the single hydration funnel.
    rememberPostLoginUrl(state.url);
    return router.parseUrl('/addboard/auth/oidc/callback');
  }
  return true;
};
